import { render, staticRenderFns } from "./settings-container.vue?vue&type=template&id=48d1ac32"
import script from "./settings-container.vue?vue&type=script&lang=js"
export * from "./settings-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports